export default __webpack_public_path__ + "images/a1109155add12bd950e375251cf4c1c5-andy-explained.svg";